import Model, { attr } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';

export interface EnumMetadata {
  'is-tio-employee': boolean;
  'governable-type': 'Employee' | 'Company';
  'governor-type': 'Role' | 'RelationshipType';
  'user-relationship-type': string;
  category?: string;
  'resting-state'?: boolean;
}

export default class EnumModel extends Model {
  @attr declare flavor: string;
  @attr declare name: string;
  @attr declare dot: string;
  @attr declare description: string;
  @attr declare metadata: EnumMetadata;

  /*************************
   **  Relationships      **
   *************************/

  /**************************
   **  Computed Properties **
   **************************/

  [Type] = 'enum' as const;
}
